import CallToAction from "./CallToAction"
import Specials from "./Specials"
import CustomersSay from './CustomersSay'
import Chicago from './Chicago'

function HomePage() {
    return (
        <>
        <CallToAction/>
        <Specials/>
        <CustomersSay/>
        <Chicago/>
        </>
      );
    }

export default HomePage;